module.exports = __webpack_public_path__ + "static/media/pda2.4e2e02d3.png";